import React, {  useEffect, useMemo, useRef, useState } from "react";
import { Button, CircularProgress, SelectChangeEvent } from "@mui/material";
import dayjs from "dayjs";
import { editGrnRowsData, EditGrnLocationState } from "../../types/types";
import Search from "../../components/dms_common/Search";
import {
  updateGrnInvoice,
} from "../../services/manageOrderService";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { getConfigData } from "../../services/configurationService";
import { getMetaData1, metaData2, getEditGrnConfig } from "./EditGrnConfig";
import "./EditGrn.css";
import { Loader } from "../../components/loader/Loader";
import CustomGenericModal from "../../components/dms_common/CustomGenericModal";
import {
  getGenericModalProps,
  initialGenericModalProps,
  GenericModal,
} from "../../features/viewOrder/ViewOrderUtils";
import { ReactComponent as PdfIcon } from "../../assets/image/svg/pdfIcon.svg";
import FormHeader from "../../components/dms_common/FormHeader";
import CustomAccordian from "../../components/dms_common/CustomAccordian";
import CustomTablewithTotalInfo from "../../components/dms_common/CustomTablewithTotalInfo";
import Header from "../../components/dms_common/Header";
import { defaultSearchFunction, filterData } from "../../components/dms_common/DmsCommonServices";
import ScreenOverlay from "../../components/dms_common/ScreenOverlay";
import { analytics, logLoadTrace } from "../../../src/firebase";
import { logEvent } from "firebase/analytics";
import { downloadGrnReport } from "../../services/manageReportService";
import { useDispatch } from "react-redux";
import { setDiscountModalState } from "../../stateManagement/actions/claims";
import NewDiscountModalPrimary from "../claimsNew/modals/NewDiscountModalPrimary";
import useShortcutKeys from "../../components/dms_common/ShortcutKeys";
import { sendSlackAlert, SlackChannel } from "../../services/slackService";
import { createScrollHandler, handleScroll, safeStringify } from "../../components/dms_common/DmsUtils";

const EditGrn = () => {
  let { orderId } = useParams();
  orderId = decodeURIComponent(orderId ?? "")
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");

  const location = useLocation();
  const { orderData, invoiceDetails, deliveryData, totalFooterValue, outletCode, currencySymbol } = location.state as EditGrnLocationState || {};
  const [rows, setRows] = useState<editGrnRowsData[]>(invoiceDetails);
  const [isRecalculated, setIsRecalculated] = useState<boolean>(false);
  const [loader, setLoader] = useState(true);
  const [primaryOrderStages, setPrimaryOrderStages] = useState<any[]>([]);
  const [reCalculateGrnButtonState, setReCalculateGrnButtonState] = useState<boolean>(false);
  const [showPricePerPiece, setShowPricePerPiece] = useState(false);
  const [genericModalProps, setGenericModalProps] = useState<GenericModal>(initialGenericModalProps);
  const [actionButtons, setActionButtons] = useState<any[]>([]);
  const [orderStatusUpdateLoader, setOrderStatusUpdateLoader] =
    useState<boolean>(false);
  const [selectedRejectionReasons, setSelectedRejectionReasons] = React.useState<string>("");
  const [searchedValue, setSearchedValue] = useState('');
  const [isScrolling, setIsScrolling] = useState(false);
  const [rejectionReasonsArraySkuLevel, setrejectionReasonArraySkuLevel] = useState<any[]>([]);
  const [isDownloading, setIsDownloading] = useState<boolean>(false); 
  const [grnSheetLoader, setGrnSheetLoader] = useState<boolean>(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [selectedSkuCode, setSelectedSkuCode] = useState<any>({});
  const showTaxPercentage = useRef<boolean>(true);
  const navigate = useNavigate();
  const { pathname } = location;
  const dispatch = useDispatch();

  const [scrollTop, setScrollTop] = useState<number>(0); 
  const scrollRef = useRef<HTMLDivElement>(null);
  const [allowTableScroll, setAllowTableScroll] = useState<boolean>(false);
  const [dontAllowContainerScroll, setDontContainerScroll] = useState(true);

  const primaryOrderPath = pathname.includes('primaryOrder');
  const onCustomAccordionToggle = (isExpanded: boolean) => {
    setIsScrolling(!isExpanded);
  }

  const handleRejectionReasonChange = (row: any, event: SelectChangeEvent<typeof selectedRejectionReasons>) => {
    const {
      target: { value }, 
    } = event;

    const matchCondition = (prevRow: any) =>
        ConfigDictionary?.batchIdConfiguration
        ? (prevRow.skuCode === row.skuCode && prevRow?.batchId === row?.batchId)
        : prevRow.skuCode === row.skuCode;
  
   setRows((prevRows) =>
      prevRows.map((prevRow) =>
        matchCondition(prevRow)
          ? { ...prevRow, skuRejectionReason: value } 
          : prevRow 
      )
    );
    
  };

  // Function to validate if all required rejection reasons are provided
  const validateRejectionReasons = () => {
    const rowsWithChangedQuantity = rows.filter(row => {
      const isAcceptedQtyChanged = (row.accpeptedQtyObj?.acceptedQty < row.accpeptedQtyObj?.totalQty) ||
        (row.accpeptedPieceQtyObj?.acceptedQty < row.accpeptedPieceQtyObj?.totalQty) ||
        (row.accpeptedOtherQtyObj?.acceptedQty < row.accpeptedOtherQtyObj?.totalQty);
      
      return isAcceptedQtyChanged;
    });

    const rowsWithoutRejectionReason = rowsWithChangedQuantity.filter(row => !row.skuRejectionReason || row.skuRejectionReason.trim() === "");
    
    return {
      isValid: rowsWithoutRejectionReason.length === 0,
      invalidRows: rowsWithoutRejectionReason,
      totalRequired: rowsWithChangedQuantity.length,
      totalProvided: rowsWithChangedQuantity.length - rowsWithoutRejectionReason.length
    };
  };



  const handlePromotionModalVisibility = (paramRow: any) => {
    setSelectedSkuCode( ConfigDictionary?.batchIdConfiguration  ? paramRow?.batchId : paramRow?.batchCode);
    dispatch(setDiscountModalState(true));
  };

  const handleEditAcceptedQuantity = (paramRow: any, value: any, changedQuantity: any,quantityType: string) => {
    const { packUnitLabelPrimary, caseUnitLabelPrimary, otherUnitLabelPrimary } = ConfigDictionary;

    if (value.totalQty >= changedQuantity) {

      const matchCondition = (row: any) =>
        ConfigDictionary?.batchIdConfiguration
          ? (row.skuCode === paramRow.skuCode && row?.batchId === paramRow?.batchId)
          : row.skuCode === paramRow.skuCode;

      setRows(prevRows =>
        prevRows.map(row =>
          matchCondition(row)
           ? {
            ...row,
            ...(quantityType === caseUnitLabelPrimary && {
            accpeptedQtyObj: {
              acceptedQty: Number(changedQuantity),
              totalQty: value.totalQty,
            },
            rejectedQtyObj: {
              rejectedQty: Number(value.totalQty) - Number(changedQuantity),
              totalQty: value.totalQty,
            },
          }),
          ...(quantityType === otherUnitLabelPrimary && {
              accpeptedOtherQtyObj: {
                acceptedQty: Number(changedQuantity),
                totalQty: value.totalQty,
              },
              rejectedOtherQtyObj: {
                rejectedQty: Number(value.totalQty) - Number(changedQuantity),
                totalQty: value.totalQty,
              },
          }),

          ...(quantityType === packUnitLabelPrimary && {
            accpeptedPieceQtyObj: {
                acceptedQty: Number(changedQuantity),
                 totalQty: value.totalQty,
            },
            rejectedPieceQtyObj: {
              rejectedQty: Number(value.totalQty) - Number(changedQuantity),
               totalQty: value.totalQty,
            }
          }),

          } : row
        )
      )
    }
    else {
        const updatedGenericModalProps = getGenericModalProps(
                "negative",
                "Accepted quantity cannot be greater than total ordered quantity.",
                "Continue",
                "",
                () => setGenericModalProps(initialGenericModalProps)
              );
            setGenericModalProps(updatedGenericModalProps);
    }
  }
  useEffect(() => {
    const hasNoRejectedQty = rows.every(
      item =>
        (item?.rejectedPieceQtyObj?.rejectedQty || 0) +
          (item?.rejectedOtherQtyObj?.rejectedQty || 0) +
          (item?.rejectedQtyObj?.rejectedQty || 0) === 0
    );
  
    setReCalculateGrnButtonState(!hasNoRejectedQty);
  }, [rows]);

  const toggleTaxInfoCollapsedStatus = (
    paramRow: editGrnRowsData,
    collapsed: boolean
  ) => {
    setRows((prevRows: editGrnRowsData[]) => {
      return prevRows.map((prevRow: editGrnRowsData) =>
        paramRow?.id === prevRow?.id ? { ...prevRow, collapsed } : prevRow
      );
    });
  };



  const columns: any[] = getEditGrnConfig(selectedRejectionReasons, handleRejectionReasonChange, handleEditAcceptedQuantity,toggleTaxInfoCollapsedStatus,rejectionReasonsArraySkuLevel, handlePromotionModalVisibility,  showPricePerPiece,showTaxPercentage.current);
  const getRejectionReasonArraySku = async () => {
    const rejectionReaons = await getConfigData("dms_configuration", "grnRejectionReasonsSku");
    setrejectionReasonArraySkuLevel(rejectionReaons[0]?.configValue ?? [])
  }

  const fetchRequiredConfig = async () => {
    const showTaxPercentageConfig = await getConfigData(
      "dms_configuration",
      "showTaxPercentage"
    );
    const showPricePerPieceConfig = await getConfigData("dms_configuration", "showPricePerPieceViewEditGrnDetails");
    setShowPricePerPiece(showPricePerPieceConfig[0]?.configValue ?? false);
    showTaxPercentage.current = showTaxPercentageConfig[0]?.configValue ?? true;
  }
  

   const init1 = async () => {
    await Promise.allSettled([getRejectionReasonArraySku(), fetchRequiredConfig()])
  };

  useEffect(() => {
    logLoadTrace(init1,"edit_grn_load_time");
  }, []);


  const createRequestBody = (outletCode: any, invoiceNumber: any, salesDetails: any) => {
    return {
        extendedAttributes: {
            return: true
        },
        outletCode: outletCode,
        type: "return",
        invoiceNumber: invoiceNumber,
        salesDetails: salesDetails
    };
}

const getTransformData = (item: any) => {
    return {
      acceptedQuantities: {
        case: {
          acceptedQty: item.accpeptedQtyObj.acceptedQty,
          totalQty: item.accpeptedQtyObj.totalQty
        },
        piece: {
          acceptedQty: item.accpeptedPieceQtyObj.acceptedQty,
          totalQty: item.accpeptedPieceQtyObj.totalQty
        },
        other: {
          acceptedQty: item.accpeptedOtherQtyObj.acceptedQty,
          totalQty: item.accpeptedOtherQtyObj.totalQty
        }
      },
      rejectedQuantities: {
        case: {
          rejectedQty: item.rejectedQtyObj.rejectedQty,
          totalQty: item.rejectedQtyObj.totalQty
        },
        piece: {
          rejectedQty: item.rejectedPieceQtyObj.rejectedQty,
          totalQty: item.rejectedPieceQtyObj.totalQty
        },
        other: {
          rejectedQty: item.rejectedOtherQtyObj.rejectedQty,
          totalQty: item.rejectedOtherQtyObj.totalQty
        }
      },
      batchCode: item.batchCode,
      skuDescription: item.skuDescription,
      rejectionReason :  item?.skuRejectionReason ?? ""
    };
}

  const handleGrnUpdate = async () => {
    try {
      setLoader(true);

      const validationResult = validateRejectionReasons();      
      if (!validationResult.isValid) {
        const updatedGenericModalProps = getGenericModalProps(
          "error",
          "Please select rejection reason to proceed.",
          "Continue",
          "",
          () => setGenericModalProps(initialGenericModalProps)
        );
        setGenericModalProps(updatedGenericModalProps);
        setLoader(false);
        return;
      }

      const salesDetails = convertData(rows);
      const transformData = rows.map((row) => getTransformData(row));
      const requestbody = createRequestBody(orderData?.outletCode,orderData?.invoiceNumber,salesDetails);
      await updateGrnInvoice(requestbody).then(() => {

        logEvent(analytics, "grn_partially_accepted", {
          "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
          "grn_id" : orderData.grnNumber,
          "order_id" : orderData.id,
          "sku_details"  : transformData
        });
        console.log(orderData.id,orderData.grnNumber,orderData.lineCount,transformData);

      const updatedGenericModalProps = getGenericModalProps(
                "success",
                "GRN recalculated successfully",
                "Continue",
                "",
                () => navigate(`/dashboard/purchase/grn/viewGrnDetails/${encodeURIComponent(orderData?.invoiceNumber??"")}`)
              );
            setGenericModalProps(updatedGenericModalProps);
            setIsRecalculated(true);
      })
      .catch((error) => {

        logEvent(analytics, "grn_partial_acceptance_failed", {
          "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
          "grn_id" : orderData.grnNumber,
          "order_id" : orderData.id,
          "error_reason":error
        });
        console.log(orderData.id,orderData.grnNumber,orderData.lineCount,error);

        const errorModalProps = getGenericModalProps(
          "error",
          "An unexpected error occurred. Please try again later.",
          "Close",
          "",
          () => setGenericModalProps(initialGenericModalProps)
        );
        setGenericModalProps(errorModalProps);
        setIsRecalculated(false);
      });
    } catch (error) {
      await sendSlackAlert(
        SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
        "GRN Update Failed - EditGrn.tsx",
        `Failed to update GRN for orderId ${orderId}. Error: ${(error as Error).message}`,
        safeStringify({ error, orderId, requestBody: createRequestBody(orderData?.outletCode, orderData?.invoiceNumber, convertData(rows)) })
      );
            const updatedGenericModalProps = getGenericModalProps(
                "error",
                "Please select rejection reason to proceed.",
                "Continue",
                "",
                () => setGenericModalProps(initialGenericModalProps)
              );
            setGenericModalProps(updatedGenericModalProps);
            setIsRecalculated(false);
    }finally {
      setLoader(false);
    }
  }

  const getTotalQuantity = (config: any,orderData:any): string[] => {
    const { packUnitLabelPrimary, caseUnitLabelPrimary, otherUnitLabelPrimary } = config;
  
    return [
      caseUnitLabelPrimary ? `${orderData?.totalCaseQuantity} ${caseUnitLabelPrimary}` : "",
      otherUnitLabelPrimary ? ` ${orderData?.totalOtherUnitQuantity} ${otherUnitLabelPrimary}` : "",
      packUnitLabelPrimary ? ` ${orderData?.totalPieceQuantity} ${packUnitLabelPrimary}` : ""
    ].filter(Boolean); // Removes empty values
  };

  const getData1 = (orderData: any) => {
    return  {totalCasePieceOtherQuantity : getTotalQuantity(ConfigDictionary,orderData),
    totalQuantity : orderData?.lineCount,
    initialAmount : orderData?.totalAmount,
    discountValue: orderData?.discountInfo?.find((item: any) => item.discountType === "Summary")?.discount || "0", 
    taxAmount : orderData?.salesDetails
    ?.filter((item: any) => 
      Number(item.caseQuantity) + Number(item.pieceQuantity) + Number(item.otherUnitQuantity) > 0
    )
    ?.reduce((sum: number, item: any) => 
      item.type !== "freeItem"
        ? sum + (item.extendedAttributes?.taxInfo?.reduce((taxSum: number, taxType: any) => taxSum + (taxType?.taxAmount || 0), 0) || 0)
        : sum
    , 0),
    netAmount : orderData?.netAmount
    }
  }

  const convertData = (originalData: any[]) => {
    return originalData?.filter((i: any) => "freeItem" != i?.type)?.map((item) => {
      const newItem : any = {
      extendedAttributes:{},
      type: item?.type,
      supplier: orderData?.supplier,
      batchCode: item?.batchCode,
      skuCode: item?.skuCode,
      pieceQuantity: item?.rejectedPieceQtyObj?.rejectedQty,
      otherUnitQuantity: item?.rejectedOtherQtyObj?.rejectedQty,
      caseQuantity: item?.rejectedQtyObj?.rejectedQty,
      remarks: (item?.rejectedPieceQtyObj?.rejectedQty + item?.rejectedOtherQtyObj?.rejectedQty + item?.rejectedQtyObj?.rejectedQty !==0) ? item?.skuRejectionReason : ""
      };
    if (ConfigDictionary?.batchIdConfiguration) {
      newItem.batchId = item?.batchId ?? "";
    }
    return newItem;
    });
  };

  const getOrderActionButtons = async () => {
    try {
      const stages = await getConfigData('order_configuration','grnStages');
      const primaryOrderStages =await getConfigData('order_configuration',"primaryOrderTrackingStages");
      setPrimaryOrderStages(primaryOrderStages[0]?.configValue ?? []);
      const btns = stages[0]?.configValue ?? []?.filter(
        (item: any) => item?.id?.toLowerCase() !== "all"
      );
      setActionButtons(btns);
    } catch (error) {
      await sendSlackAlert(
        SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
        "Error Fetching GRN Action Buttons - EditGrn.tsx",
        `Failed to fetch GRN stages or primary order stages for orderId ${orderId}. Error: ${(error as Error).message}`,
        safeStringify({ error, orderId, configKeys: ["grnStages", "primaryOrderTrackingStages"] })
      );
      console.error(error);
    }
  };

  const handleSearchValueChange = (newValue: string) => {
    setSearchedValue(newValue);
  };


  const filteredRows = useMemo(() => {
    return filterData(
      rows,
      searchedValue.toLowerCase(),
      defaultSearchFunction
    );
  }, [searchedValue, rows]);

  const handleNavigateToViewAllGrn = () => {
    navigate('/dashboard/purchase/grn')
  }    

  const downloadGrnSheet = async () => {
      if (isDownloading) return; 
      try{
        setIsDownloading(true);
        setGrnSheetLoader(true);
         const reportIdConfig = await getConfigData(
            "dms_configuration",
            "grnSheetReportId"
          );
  
        const reportId = reportIdConfig[0]?.configValue ?? "";
        const startTime = window.performance.now(); 
  
      await downloadGrnReport(
        reportId,
        "invoiceNumber",
        String(orderId),
        setSnackbarOpen,
        setIsDownloading
      )
      const endTime = window.performance.now(); 
      const durationSeconds = (endTime - startTime);
  
      logEvent(analytics, "grn_downloaded", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "grn_id" : orderData.grnNumber,
        "download_format": "pdf",
        "download_time": durationSeconds
      });
      console.log("download-grn",durationSeconds,orderData.grnNumber);
  
      }catch(e){
        await sendSlackAlert(
          SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
          "Download GRN Failed - EditGrn.tsx",
          `Failed to download GRN report for orderId ${orderId}. Error: ${(e as Error).message}`,
          safeStringify({ e, orderId, distributor_id: JSON.parse(localStorage.authContext).user.loginId })
        );
        console.log(e)
        logEvent(analytics, "grn_download_failed", {
          "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
          "grn_id" : orderData.grnNumber,
          "error_reason": e
        });
      }finally {
        setGrnSheetLoader(false);
        setIsDownloading(false);
      }
    }

  useEffect(() => {
    if (orderId) {
      setLoader(true);
      Promise.allSettled([getOrderActionButtons()]).finally(() => {
        setLoader(false);
      });
    } else {
      navigate("/dashboard/purchase/grn", { replace: true });
      return;
    }
  }, [orderId]);

  useEffect(() => {
  const handleKeyDown = (event: KeyboardEvent) => {
    if (reCalculateGrnButtonState && !orderStatusUpdateLoader && !loader) {
      if ((event.ctrlKey || event.metaKey) && event.key === 'a') {
        event.preventDefault();
        handleGrnUpdate();
      }
    }
  };

  window.addEventListener('keydown', handleKeyDown);
  return () => {
    window.removeEventListener('keydown', handleKeyDown);
  };
}, [reCalculateGrnButtonState, orderStatusUpdateLoader, loader, handleGrnUpdate]);

const { positiveCta } = useShortcutKeys();

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const handler = createScrollHandler(
      scrollRef,
      isScrolling,
      setAllowTableScroll,
      setDontContainerScroll
    );

    el.addEventListener("wheel", handler);
    el.addEventListener("scroll", handler);

    return () => {
      el.removeEventListener("wheel", handler);
      el.removeEventListener("scroll", handler);
    };
  }, [isScrolling, dontAllowContainerScroll]);

  if (loader) {
    return <Loader />;
  }

  return (
    <>
      <ScreenOverlay apply={loader} />

     <CustomGenericModal
          type={genericModalProps?.type}
          message={genericModalProps?.message}
          leftButtonText={genericModalProps?.leftButtonText}
          rightButtonText={genericModalProps?.rightButtonText}
          modalOpen={genericModalProps?.open}
          onLeftButtonClick={genericModalProps?.onLeftButtonClick}
          onRightButtonClick={genericModalProps?.onRightButtonClick}
          downloadGRNSheetLink={genericModalProps?.type === "success" ? "Download GRN for Signatures": ""}
          onClickDownloadGRNSheetLink={downloadGrnSheet}
        />

      <NewDiscountModalPrimary skuData={orderData} selectedSkuCode={selectedSkuCode} viewAllGrn={true}/>

      <div className="view_order_parent_vo" onWheel={(e) => handleScroll(e, setIsScrolling, scrollTop)}>
        <div className="view_order_header_with_search">
          <div className="view_order_header">
            <FormHeader
              parentLabel={`View ${primaryOrderPath ? "Primary Order" : "All GRN"}`}
              label={"Invoice Details"}
              childLabel={"Partially accepted GRN"}
              childLableCaseClick={handleNavigateToViewAllGrn}
              goBackToParent={() => navigate(-1)}
            />
          </div>
          <div>
            <Search searchFunction={handleSearchValueChange} />
          </div>
        </div>
        <div ref={scrollRef} style={{
          gap: "14px",
          overflow: (dontAllowContainerScroll) ? "hidden" : "scroll",
          height: "100%",
          scrollbarWidth: ConfigDictionary?.showTableScrollbar ? "thin" : "none",
        }}
          onScroll={(e) => {
            if (ConfigDictionary?.showTableScrollbar){
              const currentScrollTop = e.currentTarget.scrollTop;
              if (currentScrollTop > scrollTop) {
                setIsScrolling(true); // scrolling down
              } else if (currentScrollTop < scrollTop) {
                setIsScrolling(false); // scrolling up
              } 
            }
          }}  
        >
          <CustomAccordian
            expanded={!isScrolling}
            onCustomAccordionToggle={onCustomAccordionToggle}
            isSecondHalf={true}
            metaData1={getMetaData1(currencySymbol)}
            data1={getData1(orderData)}
            metaData2={metaData2}
            data2={{
              supplierCode:  orderData?.supplier,
              supplierName : orderData?.supplierName,
              deliveryDate : dayjs(orderData?.creationTime).add(48, "hour").format("YYYY-MM-DD HH:mm:ss")
            }}
            header={`GRN for Invoice No. ${orderData?.invoiceNumber}`}
            label1="Invoice Summary"
            label2="Supplier Summary"
            dateAndTimeLabel="Invoice Date & time"
            dateAndTimeValue={orderData?.creationTime}
            statusConfig={primaryOrderStages}
            status={orderData?.orderStatus}
          />
          <div style={{height: "100%", position: "sticky", top: "0"}}>
            {orderStatusUpdateLoader ? (
              <CircularProgress sx={{ margin: "0 auto" }} />
            ) : (
              <div className="view_order_details_vo">
                <div className="grn_header">
                  <Header
                    title={
                      !isRecalculated
                        ? `Partially Accepted GRN: Invoice No. ${orderData?.invoiceNumber}`
                        : `Accepted GRN: Invoice No. ${orderData?.invoiceNumber}`
                    }
                  />

                </div>
                {loader ? (
                  <Loader />
                ) : (
                    <CustomTablewithTotalInfo
                      data={filteredRows?.filter((s: any) => s?.type !== "freeItem")}
                      columns={columns}
                      totals={totalFooterValue}
                      headerBackgroundColor="#F0FBFF"
                      allowTableScroll={allowTableScroll}
                      setScrollTop={setScrollTop}
                      children={
                        <div className="view_order_update_wrapper">
                          <div className="view_order_action_buttons_wrapper">
                            <Button
                              className="view_order_action_button"
                              key={"CONFIRMED"}
                              disabled={!reCalculateGrnButtonState}
                              sx={{
                                color: `#ffffff !important`,
                                fontWeight: 500,
                                fontSize: `11px !important`,
                                lineHeight: "2.25",
                                backgroundColor: `var(--dashboard-theme-color)`,
                                border: `1px solid var(--dashboard-theme-color) !important`,
                                cursor: "pointer",
                                paddingLeft: "12px",
                                textTransform: "none",
                                height: "84%",
                                "&.Mui-disabled": {
                                  backgroundColor: "#dedede !important", 
                                  color: "#7c7c7c !important", 
                                  border: "1px solid #dedede !important",
                                  cursor: "not-allowed",
                                },
                                "&:hover": {
                                  backgroundColor: `var(--dashboard-theme-color)`,
                                },
                                "& .MuiButton-startIcon": {
                                  marginRight: "4px",
                                },
                              }}
                              onClick={() => {
                                handleGrnUpdate();
                              }}
                            >
                              {"Re-Calculate GRN"}
                              &nbsp;<span style={{fontSize:"9.5px"}}>{positiveCta}</span>
                            </Button>
                          </div>
                        </div>
                      }
                    />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <div></div>
    </>
  );
};

export default EditGrn;
